import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { languagesList } from '../i18n';

export default function SiteMap() {
  const { t } = useTranslation();

  return (
    <div className="flex-grow w-full max-w-4xl mx-auto p-4 sm:p-8 mt-8">
      <Helmet>
        <title>{t('meta_title_sitemap')}</title>
        <meta name="description" content={t('meta_desc_sitemap')} />
        
        {/* Social Media Meta */}
        <meta property="og:title" content={t('meta_title_sitemap')} />
        <meta property="og:description" content={t('meta_desc_sitemap')} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('meta_title_sitemap')} />
        <meta name="twitter:description" content={t('meta_desc_sitemap')} />

        {/* Structured Data */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "${t('meta_title_sitemap')}",
              "description": "${t('meta_desc_sitemap')}"
            }
          `}
        </script>
      </Helmet>
      <h1 className="text-3xl font-bold mb-6">{t('sitemap_title')}</h1>
      
      <div className="bg-white/5 border border-white/10 rounded-3xl p-8 shadow-xl">
        <h2 className="text-xl font-semibold mb-6 pb-2 border-b border-white/10">{t('sitemap_pages')}</h2>
        <ul className="space-y-3 mb-10">
          <li>
            <Link to="/" className="text-indigo-400 hover:text-indigo-300 transition-colors">Home (Barcode Generator)</Link>
          </li>
          <li>
            <Link to="/terms" className="text-indigo-400 hover:text-indigo-300 transition-colors">{t('terms_of_use')}</Link>
          </li>
          <li>
            <Link to="/privacy" className="text-indigo-400 hover:text-indigo-300 transition-colors">{t('privacy_policy')}</Link>
          </li>
          <li>
            <Link to="/mobile" className="text-indigo-400 hover:text-indigo-300 transition-colors">{t('mobile_app')}</Link>
          </li>
          <li>
            <Link to="/contacts" className="text-indigo-400 hover:text-indigo-300 transition-colors">{t('contacts')}</Link>
          </li>
        </ul>

        <h2 className="text-xl font-semibold mb-6 pb-2 border-b border-white/10">{t('sitemap_languages')}</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {languagesList.map(l => (
            <Link 
              key={l.code} 
              to={l.code === 'en' ? '/' : `/${l.code}/`} 
              className="text-sm text-white/70 hover:text-white transition-colors flex items-center gap-2"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-slate-700"></span>
              {l.label} ({l.code})
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
